import React from "react";
import { Row, Col } from "react-bootstrap";
// import Documents from "./Documents";
import VideoList from "./VideoList";
import "../Learning.css";
import { useParams } from "react-router-dom";

const Awareness = () => {
  return (
    <Row className="b_shadow mb-3">
      <Col lg={12} md={12} sm={12} className=" bgwhite">
        <h3 className="pl20 cardheader" style={{ paddingTop: 16 }}>
          Awareness
        </h3>
      </Col>

      <Col lg={12}>
        <VideoList />
      </Col>

      {/* <Col lg={12}>
        <Documents />
      </Col> */}
    </Row>
  );
};

export default Awareness;
